import {DefaultTheme} from 'styled-components';

import {ThemeTypesEnum} from './themeTypes';

export const isDarkSidebarTheme = (theme: DefaultTheme) => theme.type === ThemeTypesEnum.DARK_SIDEBAR;
export const isExpandedDarkTheme = (theme: DefaultTheme) => theme.type === ThemeTypesEnum.EXPANDED_DARK;
export const isDarkTheme = (theme: DefaultTheme) =>
  theme.type === ThemeTypesEnum.DARK || isDarkSidebarTheme(theme) || isExpandedDarkTheme(theme);
